var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEvaluation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 84,
    viewBox: "0 0 85 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.0883789,
    width: 84,
    height: 84,
    rx: 42,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.6135 28.5628L50.5643 28.5625C50.8855 28.5625 51.1935 28.6912 51.4207 28.9204C51.6478 29.1496 51.7753 29.4604 51.7752 29.7844L51.7734 35.8639L49.3517 35.8633L49.3532 31.0057L34.8244 31.0059L34.8243 35.8637L32.4025 35.8636L32.4027 29.7843C32.4027 29.1097 32.9448 28.5628 33.6135 28.5628ZM49.3542 52.9944L49.3517 48.1369L51.7734 48.1359L51.7764 54.2154C51.7765 54.5395 51.649 54.8504 51.4219 55.0795C51.1948 55.3088 50.8868 55.4375 50.5655 55.4375H33.6122C33.2911 55.4375 32.983 55.3087 32.7559 55.0796C32.5289 54.8505 32.4013 54.5398 32.4014 54.2157L32.4025 48.1361L34.8243 48.1365L34.8233 52.9944H49.3542Z",
    fill: "#466AEF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.9639 50.75H40.2139V48.25H43.9639V50.75Z",
    fill: "#466AEF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3401 35.7495L33.3402 29.4998L50.8389 29.4995L50.8369 35.7495M33.3401 48.2495L33.3389 54.4995H50.84L50.8369 48.2495",
    stroke: "#466AEF",
    strokeWidth: 1.875,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.704 37.3652L46.9363 39.133L49.8024 41.9991L46.9363 44.8653L48.704 46.633L53.338 41.9991L48.704 37.3652Z",
    fill: "#466AEF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.4725 37.3657L37.2403 39.1335L34.3742 41.9996L37.2403 44.8657L35.4725 46.6335L30.8386 41.9996L35.4725 37.3657Z",
    fill: "#466AEF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvaluation);
export default __webpack_public_path__ + "static/media/Evaluation.81653b410b6584b7340f3525b9849c68.svg";
export { ForwardRef as ReactComponent };